export default {
  cancelPickup: {
    id: 'bo_sellers-orders-components-orders_table-actions-cancel_pickup',
    defaultMessage: 'Cancel pickup',
  },
  pickupCancelled: {
    id: 'bo_sellers-orders-components-orders_table-actions-pickup_cancelled',
    defaultMessage: 'Pickup cancelled',
  },
  requestPickup: {
    id: 'bo_sellers-orders-components-orders_table-actions-request_pickup',
    defaultMessage: 'Request pickup',
  },
  pickupBetween: {
    id: 'bo_sellers-orders-components-orders_table-pick_up_between',
    defaultMessage: 'between {startHour}-{endHour}',
  },
} as const
